import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { NpPermissionUtils } from '../../core/np-permission-utils';
import { NpUserLoginService } from '../../core/np-user-login-service';

@Directive({
  selector: '[npHasAnyRole]',
  standalone: true,

})
export class NpHasAnyRoleDirective {

  // templateRef = inject(TemplateRef<any>)
  // container = inject(ViewContainerRef)
  // userLoginService = inject(NpUserLoginService)

  constructor(private templateRef: TemplateRef<any>,
    private container: ViewContainerRef, private userLoginService: NpUserLoginService) { }

  @Input('npHasAnyRole')
  set npHasAnyRole(roles: string | string[]) {
    const targetRoles = NpPermissionUtils.convertStrignArray(roles);
    NpPermissionUtils.hasAnyRole(targetRoles, this.userLoginService.getAuthorities()) ? this.container.createEmbeddedView(this.templateRef) : this.container.clear();
  }

}
